import Vue from 'vue';
import unionInputs from 'union_inputs';
import unionComponents from 'union_components';
import VueGtm from '@gtm-support/vue2-gtm';
import Navigation from './components/navigation/Navigation.vue';
import SimpleNavigation from './components/navigation/SimpleNavigation.vue';
import Footer from './components/footer/Footer.vue';
import TransparentFooter from './components/footer/TransparentFooter.vue';
import CheckBox from './components/inputboxes/Checkbox.vue';
import RadioBox from './components/inputboxes/RadioBox.vue';
import CircleRadioBox from './components/inputboxes/CircleRadioBox.vue';
import Rating from './components/rating/Rating.vue';
import Stars from './components/rating/Stars.vue';
import Upload from './components/Upload.vue';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.component('navigation', Navigation);
Vue.component('simple-navigation', SimpleNavigation);
Vue.component('app-footer', Footer);
Vue.component('transparent-footer', TransparentFooter);
Vue.component('check-box', CheckBox);
Vue.component('radio-box', RadioBox);
Vue.component('circle-radio-box', CircleRadioBox);
Vue.component('upload', Upload);
Vue.component('rating', Rating);
Vue.component('stars', Stars);

Vue.use(unionInputs);
Vue.use(unionComponents);

Vue.use(VueGtm, {
  id: 'GTM-MQMNF7',
  defer: false,
  enabled: true,
  debug: true,
  loadScript: true,
  vueRouter: false,
  ignoredViews: [],
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
